import comp from "./StaffList";
export default comp;
